module.exports = __webpack_public_path__ + "img/english.b7bd70a0.png";